import { COUNTRIES } from '@config/constants'
import { dangerouslyGetRuntimeConfig } from '@config/variables'
import { dynamicImport, insertIf } from '@core/helpers'
import { ROUTES } from '@router'

const { FF_BUYBACK_CUSTOMER_UK } = dangerouslyGetRuntimeConfig()

const buybackRoutes = [
  {
    path: 'buyback/:pageName',
    component: () => dynamicImport(import('./Landing.vue')),
    name: ROUTES.CMS.BUYBACK,
  },
  {
    path: 'buyback/:pageName/:pageCategory',
    component: () => dynamicImport(import('./Landing.vue')),
    name: ROUTES.CMS.BUYBACK_CATEGORY,
  },
]

const sellerRoutes = [
  {
    path: 'seller/:pageName',
    component: () => dynamicImport(import('./Landing.vue')),
    name: ROUTES.CMS.SELLER,
  },
]
export default ({ country }) => {
  const shouldAddBuybackRoutes = [
    COUNTRIES.FR,
    COUNTRIES.DE,
    COUNTRIES.US,
    COUNTRIES.ES,
    ...((FF_BUYBACK_CUSTOMER_UK && [COUNTRIES.GB]) || []),
  ].includes(country)

  return [
    {
      path: 'b/:pageName',
      component: () => dynamicImport(import('./Landing.vue')),
      name: ROUTES.CMS.BRAND_STORE,
    },
    {
      path: 'b/:pageName/:pageCategory',
      component: () => dynamicImport(import('./Landing.vue')),
      name: ROUTES.CMS.BRAND_STORE_CATEGORY,
    },
    {
      path: 'e/:pageName',
      component: () => dynamicImport(import('./Landing.vue')),
      name: ROUTES.CMS.EVENT,
    },
    {
      path: 'business/:pageName',
      component: () => dynamicImport(import('./Landing.vue')),
      name: ROUTES.CMS.BUSINESS,
    },
    ...insertIf(shouldAddBuybackRoutes, buybackRoutes),
    ...sellerRoutes,
  ]
}
